import { render, staticRenderFns } from "./specialTreatment.vue?vue&type=template&id=3c9ab0b9"
import script from "./specialTreatment.vue?vue&type=script&lang=js"
export * from "./specialTreatment.vue?vue&type=script&lang=js"
import style0 from "./specialTreatment.vue?vue&type=style&index=0&id=3c9ab0b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports